<script>
    export default {
        name: "CategoriesData",
        computed: {
            categoryItems() {
                return this.$store.getters.categories.map(item => {
                    switch (item.systemName) {
                        case 'semena' :
                            item.icon = 'seeds';
                            break;
                        case 'udobreniya' :
                            item.icon = 'sprout';
                            break;
                        case 'pestitsidy' :
                            item.icon = 'shield-check-outline';
                            break;
                        default:
                            item.icon = false;
                    }
                    return item;
                });
            },
        },
    }
</script>

<style scoped>

</style>
